import React, { Component } from 'react';
import AdminColorDot from './AdminColorDot';

class RarityList extends Component {
    render() {
        const { rarity, onSelectRarity, onNewRarity } = this.props;

        return (
            <div className='admin_list'>
                <button onClick={onNewRarity}>Create New Rarity</button>

                {rarity.map((rarity, index) => (
                    <button
                        type="button"
                        className="listElement admin-color-list-element"
                        key={rarity.id || index}
                        onClick={() => onSelectRarity(rarity)}
                    >
                        <AdminColorDot item={rarity} />
                        {rarity.name}
                    </button>
                ))}

            </div>
        );
    }
}

export default RarityList;
